var map = {
	"./Delete": [
		"08a1",
		"chunk-2d0a50ee"
	],
	"./Delete.vue": [
		"08a1",
		"chunk-2d0a50ee"
	],
	"./Page": [
		"0df9",
		"chunk-55f11db5",
		"chunk-30074148"
	],
	"./Page.vue": [
		"0df9",
		"chunk-55f11db5",
		"chunk-30074148"
	],
	"./Unsaved": [
		"775e",
		"chunk-2d0d76a6"
	],
	"./Unsaved.vue": [
		"775e",
		"chunk-2d0d76a6"
	],
	"./page/Basket": [
		"97a7",
		"chunk-55f11db5"
	],
	"./page/Basket.vue": [
		"97a7",
		"chunk-55f11db5"
	],
	"./page/Blocks": [
		"ea25",
		"chunk-50cfba2d"
	],
	"./page/Blocks.vue": [
		"ea25",
		"chunk-50cfba2d"
	],
	"./page/Closed": [
		"720f",
		"chunk-09d30adb"
	],
	"./page/Closed.vue": [
		"720f",
		"chunk-09d30adb"
	],
	"./page/Countdown": [
		"8326",
		"chunk-dcdfb8b2"
	],
	"./page/Countdown.vue": [
		"8326",
		"chunk-dcdfb8b2"
	],
	"./page/Head": [
		"42ef",
		"chunk-0b9de527"
	],
	"./page/Head.vue": [
		"42ef",
		"chunk-0b9de527"
	],
	"./page/Heading": [
		"0a45",
		"chunk-995fd950"
	],
	"./page/Heading.vue": [
		"0a45",
		"chunk-995fd950"
	],
	"./page/Success": [
		"7aed",
		"chunk-4ed90e9a"
	],
	"./page/Success.vue": [
		"7aed",
		"chunk-4ed90e9a"
	],
	"./page/Summary": [
		"e247",
		"chunk-534e1d28"
	],
	"./page/Summary.vue": [
		"e247",
		"chunk-534e1d28"
	],
	"./page/Text": [
		"bc89",
		"chunk-792101a3"
	],
	"./page/Text.vue": [
		"bc89",
		"chunk-792101a3"
	],
	"./page/basket/Bar": [
		"3bfb",
		"chunk-44df6333"
	],
	"./page/basket/Bar.vue": [
		"3bfb",
		"chunk-44df6333"
	],
	"./page/basket/Review": [
		"90cb",
		"chunk-36ee2e88"
	],
	"./page/basket/Review.vue": [
		"90cb",
		"chunk-36ee2e88"
	],
	"./page/basket/review/Discount": [
		"03e1",
		"chunk-46e16764"
	],
	"./page/basket/review/Discount.vue": [
		"03e1",
		"chunk-46e16764"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f7f0";
module.exports = webpackAsyncContext;